import { PartialTheme } from "@nivo/theming";
import { Theme, useTheme } from "app/context/ThemeContext";

export const useChartTheme = (): PartialTheme => {
    const { theme } = useTheme();

    return {
        text: {
            fill: theme === Theme.Dark ? "#A7A7A7" : "#333333",
        },
        tooltip: {
            container: {
                color: "#000000",
            },
        },
    };
};
